import { ReactNode } from 'react';
import { CookiesProvider } from 'react-cookie';

interface Props {
    children: ReactNode;
}

function AppCookieProvider({ children }:Props) {
    return (
        <CookiesProvider>
            {children}
        </CookiesProvider>
    );
}

export default AppCookieProvider;
